module.exports = __webpack_public_path__ + "static/media/color-wall.7257a771.gif";